var cache = new Map();
/**
 * æ³¨åè®¡ç®åå´ççç®æ³
 * @param type æ¹æ³å
 * @param method æ¹æ³
 */
export function register(type, method) {
    cache.set(type, method);
}
/**
 * è·åè®¡ç®åå´ççç®æ³
 * @param type æ¹æ³å
 */
export function getMethod(type) {
    return cache.get(type);
}
//# sourceMappingURL=register.js.map